<div class="loader-theme">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</div>
